
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/apple",
      function () {
        return require("private-next-pages/shop/apple/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/apple"])
      });
    }
  